import GetSession from "./get.js";
import sessionData, { type ClientSession } from "./data.js";

/**
 * Update session
 * @param {string} sessionId - The sessionId of the session to update
 * @param {object} updates - The updates to apply to the session
 * @returns {object|null} - The updated session data or null if the session does not exist
 */

function update(sessionId: string, updates: unknown, pathArr?: string | string[]): ClientSession | null {
	var path = Array.isArray(pathArr) ? pathArr.join(".") : pathArr;
	const session = GetSession(sessionId);
	if (!session) return null;
	const updated = setDeep({ ...session } as Record<string, unknown>, updates, path) as ClientSession;

	sessionData.set(sessionId, updated);
	return updated;
}

function setDeep(obj: Record<string, unknown>, value: unknown, path: string | null | undefined): Record<string, unknown> {
	if (!path) {
		// Merge at root
		return { ...obj, ...(value as Record<string, unknown>) };
	}

	const keys = path.split(".");
	const lastKey = keys.pop()!;
	const target = keys.reduce<Record<string, unknown>>((acc, key) => {
		if (!acc[key] || typeof acc[key] !== "object") acc[key] = {};
		return acc[key] as Record<string, unknown>;
	}, obj);

	const existing = target[lastKey];
	const isPlainObjectMerge =
		existing !== null &&
		value !== null &&
		!Array.isArray(existing) &&
		!Array.isArray(value) &&
		typeof existing === "object" &&
		typeof value === "object";

	// Arrays and scalars are replaced outright; plain objects are shallow-merged.
	target[lastKey] = isPlainObjectMerge
		? { ...(existing as object), ...(value as object) }
		: value;

	return obj;
}

export { update };

export default update;
